import * as React from "react";
import styled from "styled-components";
import MediaLazyTransitionWrapper from "common/components/mediaWrapper";

const Image = styled.img`
  display: block;
  max-width: 100%;
  width: 100%;
`;

const Wrapper = styled.a`
  display: block;
  position: relative;
  z-index: ${props => props.theme.zDefault};
`;

const ImageComponent = ({
  src,
  width,
  height,
  srcSet,
  previewColor,
  blurHash,
  alt,
}: {
  src: string;
  width?: number;
  height?: number;
  srcSet?: string;
  previewColor?: string;
  blurHash?: string;
  alt?: string;
}) => {
  const element = (
    <Image
      alt={alt}
      src={src}
      srcSet={srcSet}
      style={{
        backgroundColor: blurHash ? undefined : previewColor,
      }}
    />
  );
  if (!width || !height) {
    return element;
  }
  return (
    <Wrapper href={src} target="_blank">
      <MediaLazyTransitionWrapper
        src={src}
        srcSet={srcSet}
        type="image"
        width={width}
        height={height}
        blurHash={blurHash}
        previewColor={previewColor}
      >
        {element}
      </MediaLazyTransitionWrapper>
    </Wrapper>
  );
};

export default React.memo(ImageComponent);
